<template>
  <div class="button outlined" @click="showModal()" style="margin-top: 0.8rem;">（会員訴求）</div>
  <div class="form formSignupAppeal" v-if="show" @click.self="closeModal">
    <div class="box">
      <div class="contents">
        <div class="signupAppeal">
          <h3>
            無料会員登録で<br />
            お気に入り機能が使えます
          </h3>
          <div class="next">
            <a class="button" href="/signup/step_1">登録へ進む</a>
            <a class="textLink" href="/login">アカウントをお持ちの方はこちら</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>
